import { render } from "./Enable2faView.vue?vue&type=template&id=917eed28"
import script from "./Enable2faView.vue?vue&type=script&lang=js"
export * from "./Enable2faView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/views/Enable2faView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "917eed28"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('917eed28', __exports__)) {
    api.reload('917eed28', __exports__)
  }
  
  module.hot.accept("./Enable2faView.vue?vue&type=template&id=917eed28", () => {
    api.rerender('917eed28', render)
  })

}


export default __exports__